module.exports = __webpack_public_path__ + "static/media/white-appstore.c393dc7c.png";